import { css } from '@emotion/react'
import {
  ColorPrimitives,
  gemVar,
  LineWeight,
  Size,
  Spacing,
  ThemedColors,
  Typography,
} from '@opallabs/gem'
import { avatarParts, avatarRoot } from '@opallabs/lapidary'

export const container = css({
  alignItems: 'center',
  color: gemVar(ThemedColors.TextPrimary),
  display: 'inline-flex',
  inlineSize: 'fit-content',

  '&.legacy-dark': {
    // Force light theme on avatar in moment sidebar
    // because small size makes dark theme hard to see
    [`.${avatarRoot} [part~='${avatarParts.text}']`]: {
      backgroundColor: gemVar(ColorPrimitives.N150),
      borderRadius: 'inherit',
      boxShadow: `inset 0 0 0 ${LineWeight.Small}px ${gemVar(ColorPrimitives.N300)}`,
      color: gemVar(ColorPrimitives.N999),
    },
  },

  '&:hover': {
    cursor: 'pointer',
  },
})
export const containerDynamic = (displayName: boolean) =>
  css({
    backgroundColor: displayName
      ? gemVar(ThemedColors.Surface2)
      : 'transparent',
    borderRadius: displayName ? Size.Rounding * 3.5 : 0,
    columnGap: displayName ? Spacing.S : Spacing.XS,
  })

export const avatar = css({
  '&.fallback': {
    backgroundColor: gemVar(ThemedColors.Surface2),
    border: `solid 1px ${gemVar(ThemedColors.StrokeSecondary3)}`,
  },
})

export const text = css({
  ...Typography.T300,
  color: gemVar(ThemedColors.TextSecondary),
  marginBlock: Spacing.XS,
})

export const tooltipButton = css({
  '&.icon-only': {
    blockSize: Spacing.L,
    paddingInline: Spacing.XS,
  },
})
